
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[language]/[country]/[...slug]",
      function () {
        return require("private-next-pages/[language]/[country]/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[language]/[country]/[...slug]"])
      });
    }
  